import script from "./OperatorDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorDetail.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorDetail.vue?vue&type=style&index=0&id=c2d41d42&lang=scss"

const __exports__ = script;

export default __exports__